const NAMESPACE = "modulegroup";

const KEYS = {
    pvArraySectionLabel: "pvArraySectionLabel",
    deleteArrayButtonText: "deleteArrayButtonText",
    tiltLabel: "tiltLabel",
    tiltBoundaries: "tiltBoundaries",
    tiltNotInputMessage: "tiltNotInputMessage",
    tiltNotAnIntegerMessage: "tiltNotAnIntegerMessage",
    tiltOutOfRangeMessage: "tiltOutOfRangeMessage",
    azimuthLabel: "azimuthLabel",
    azimuthBoundaries: "azimuthBoundaries",
    azimuthNotInputMessage: "azimuthNotInputMessage",
    azimuthNotAnIntegerMessage: "azimuthNotAnIntegerMessage",
    azimuthOutOfRangeMessage: "azimuthOutOfRangeMessage",
    trackingLabel: "trackingLabel",
    trackingHelpText: "trackingHelpText",
    fixedTrackingOption: "fixedTrackingOption",
    singleAxisTrackingOption: "singleAxisTrackingOption",
    dualAxisTrackingOption: "dualAxisTrackingOption",
    shadingLabel: "shadingLabel",
    shadingMonthlySubtitleHeader: "shadingMonthlySubtitleHeader",
    shadingMonthlySubtitleExplanatory: "shadingMonthlySubtitleExplanatory",
    shadingNonmonthlySubtitleHeader: "shadingNonmonthlySubtitleHeader",
    shadingNonmonthlySubtitleValidRange: "shadingNonmonthlySubtitleValidRange",
    shadingNonmonthlySubtitleExplanatory: "shadingNonmonthlySubtitleExplanatory",
    monthlyShadingOutOfRangeMessage: "monthlyShadingOutOfRangeMessage",
    nonmonthlyShadingOutOfRangeMessage: "nonmonthlyShadingOutOfRangeMessage",
    updatedModelSuffix: "updatedModelSuffix",
    pvArrayDescriptionLabel: "pvArrayDescriptionLabel",
    pvArrayDescriptionPlaceholder: "pvArrayDescriptionPlaceholder"
};

const MESSAGES = {
    [KEYS.pvArraySectionLabel]: {
        value: "PV Array",
        comment: "Label for PV Array section"
    },
    [KEYS.deleteArrayButtonText]: {
        value: "Delete Array",
        comment: "Text for button to delete array"
    },
    [KEYS.tiltLabel]: {
        value: "Tilt",
        comment: "Label for tilt input"
    },
    [KEYS.tiltBoundaries]: {
        value: "(0\u00B0 to 90\u00B0)",
        comment: "Boundaries for meaningful tilt input values"
    },
    [KEYS.tiltNotInputMessage]: {
        value: "Please fill in tilt angle.",
        comment: "Validation message displayed if the tilt is not input"
    },
    [KEYS.tiltNotAnIntegerMessage]: {
        value: "Tilt must be a whole number.",
        comment: "Validation message displayed if the tilt input is not an integer"
    },
    [KEYS.tiltOutOfRangeMessage]: {
        value: "Tilt must be a whole number between 0 and 90 degrees.",
        comment: "Validation message displayed if tilt input is out of range"
    },
    [KEYS.azimuthLabel]: {
        value: "Azimuth",
        comment: "Label for azimuth input"
    },
    // \u00B0 === °, but there are several very similar symbols, so just use the code directly
    [KEYS.azimuthBoundaries]: {
        value: "(0\u00B0 to 359\u00B0)",
        comment: "Boundaries for meaningful azimuth input values"
    },
    [KEYS.azimuthNotInputMessage]: {
        value: "Please fill in azimuth angle.",
        comment: "Validation message displayed if the azimuth is not input"
    },
    [KEYS.azimuthNotAnIntegerMessage]: {
        value: "Azimuth must be a whole number.",
        comment: "Validation message displayed if the azimuth input is not an integer"
    },
    [KEYS.azimuthOutOfRangeMessage]: {
        value: "Azimuth must be a whole number between 0 and 359 degrees.",
        comment: "Validation message displayed if azimuth input is out of range"
    },
    [KEYS.trackingLabel]: {
        value: "Tracking",
        comment: "Label for tracking input field"
    },
    [KEYS.trackingHelpText]: {
        value: "For Fixed and Single-Axis Tracking systems, the Tilt and Azimuth must be input.  In the case of Single-Axis Tracking systems, the Tilt and Azimuth refer to the orientation of the axis of rotation.",
        comment: "Help text for tracking input field"
    },
    [KEYS.fixedTrackingOption]: {
        value: "Fixed",
        comment: "Label for fixed tracking option"
    },
    [KEYS.singleAxisTrackingOption]: {
        value: "Single Axis",
        comment: "Label for single axis tracking option"
    },
    [KEYS.dualAxisTrackingOption]: {
        value: "Dual Axis",
        comment: "Label for dual axis tracking option"
    },
    [KEYS.shadingLabel]: {
        value: "Shading",
        comment: "Label for shading input section"
    },
    [KEYS.shadingMonthlySubtitleHeader]: {
        value: "% Solar Access",
        comment: "Label explaining what values should be input for shading in monthly context"
    },
    [KEYS.shadingMonthlySubtitleExplanatory]: {
        value: "(100 or blank = No Shading)",
        comment: "Label explaining interpretation of input values for shading in monthly context"
    },
    // \u00B0 === °, but there are several very similar symbols, so just use the code directly
    [KEYS.shadingNonmonthlySubtitleHeader]: {
        value: "Solar Obstruction Angle (\u00B0)",
        comment: "Label explaining what values should be input for shading in non-monthly context"
    },
    [KEYS.shadingNonmonthlySubtitleValidRange]: {
        value: "0\u00B0 to 90\u00B0",
        comment: "Label explaining range of valid inputs for shading field in non-monthly context"
    },
    [KEYS.shadingNonmonthlySubtitleExplanatory]: {
        value: "(0\u00B0 or blank = no shading)",
        comment: "Label explaining interpretation of input values for shading in non-monthly context"
    },
    [KEYS.monthlyShadingOutOfRangeMessage]: {
        value: "Shading inputs must be a number between 0 and 100.",
        comment: "Validation message displayed if a monthly shading input is out of range"
    },
    [KEYS.nonmonthlyShadingOutOfRangeMessage]: {
        value: "Shading inputs must be a number between 0 and 90 degrees.",
        comment: "Validation message displayed if a non-monthly shading input is out of range"
    },
    [KEYS.updatedModelSuffix]: {
        value: " - UPDATED",
        comment: "Suffix to use on a model definition which is an updated version of the stored model"
    },
    [KEYS.pvArrayDescriptionLabel]: {
        value: "PV Array Description",
        comment: "Label for PV Array Description"
    },
    [KEYS.pvArrayDescriptionPlaceholder]: {
        value: "Enter a description for your PV Array here",
        comment: "Placeholder for PV Array Description. Disappears once a user begins typing in the text box"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
